<template>
  <div class="contact-page container py-5">
    <div class="row g-4">
      <!-- Contact Details -->
      <div class="col-lg-5">
        <div class="details-card">
          <h3 class="details-heading">Contact Details</h3>

          <div class="detail-item">
            <span class="detail-icon">
              <i class="bi bi-telephone"></i>
            </span>
            <div>
              <p class="detail-label">Emergency call</p>
              <p class="detail-value">+880 1882 124 009</p>
            </div>
          </div>

          <div class="detail-item">
            <span class="detail-icon">
              <i class="bi bi-envelope"></i>
            </span>
            <div>
              <p class="detail-label">General communication</p>
              <p class="detail-value">sehrishmart.official@gmail.com</p>
            </div>
          </div>

          <hr class="my-4" />

          <!-- <h4 class="section-title">Store Address</h4>
          <p class="address-text">
          </p> -->

          <h4 class="section-title mt-4">Social links</h4>
          <div class="social-links">
            <a href="https://www.facebook.com/sehrishmart55/" target="_blank" class="social-icon"><i class="bi bi-facebook"></i></a>
            <a href="https://www.instagram.com/sehrish_mart.official/" target="_blank" class="social-icon"><i class="bi bi-instagram"></i></a>
            <a href="https://wa.me/8801882124009" target="_blank" class="social-icon"><i class="bi bi-whatsapp"></i></a>
          </div>
        </div>
      </div>

      <!-- Contact Form -->
      <div class="col-lg-7">
        <h2 class="form-heading">Feel free to contact us</h2>
        <h4 class="contact-title">We Would Love To Hear From You.</h4>
        <form @submit.prevent="submitForm">
          <div class="mb-4">
            <label class="form-label">Name</label>
            <input
              type="text"
              class="form-control form-control-lg"
              placeholder="Full Name"
              v-model="form.name"
              required
            />
          </div>
          <div class="mb-4">
            <label class="form-label">Phone</label>
            <input
              type="text"
              class="form-control form-control-lg"
              placeholder="Phone number"
              v-model="form.phoneNumber"
              required
            />
          </div>
          <div class="mb-4">
            <label class="form-label">Message</label>
            <textarea
              class="form-control form-control-lg"
              rows="6"
              placeholder="Enter Your Message"
              v-model="form.message"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            class="btn btn-dark btn-lg"
            :disabled="isLoading"
          >
            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            Send Messege
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/globals";

export default {
  name: "ContactPage",
  data() {
    return {
      isLoading: false,
      form: {
        name: "",
        phoneNumber: "",
        message: "",
      },
    };
  },
  methods: {
    async submitForm() {
      this.isLoading = true;
      const { name, phoneNumber, message } = this.form;
      // Basic empty check
      if (!name.trim() || !phoneNumber.trim() || !message.trim()) {
        this.$root.showToast({
          message: "Please fill in all required fields.",
          status: "danger",
          duration: 3000,
        });
        this.isLoading = false;
        return;
      }
      try {
        const response = await axios.post(`${BASE_URL}/api/common/contact`, {
          name: this.form.name,
          phoneNumber: this.form.phoneNumber,
          message: this.form.message,
        });
        if (response.data.status) {
          this.$root.showToast({
            message: "Form submitted. Thanks!",
            status: "success",
            duration: 3000,
          });
          this.form = {
            name: "",
            phoneNumber: "",
            message: "",
          };
        } else {
          this.$root.showToast({
            message: "Submission failed. Please try again later.",
            status: "danger",
            duration: 3000,
          });
        }
      } catch (error) {
        this.$root.showToast({
          message: "Submission failed. Please try again later.",
          status: "danger",
          duration: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-page {
  background: #fff;

  .details-card {
    background: #f7f8fc;
    border-radius: 20px;
    padding: 2.5rem;
    height: 100%;
  }

  .details-heading {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 2rem;
    color: #1e1e2d;
  }

  .detail-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }

  .detail-icon {
    flex: 0 0 auto;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    color: #d9506b;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  .detail-label {
    margin: 0;
    color: #6b6b7b;
    font-size: 1rem;
  }

  .detail-value {
    margin: 0;
    font-weight: 700;
    color: #1e1e2d;
    font-size: 1.1rem;
  }

  .section-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e1e2d;
    margin-bottom: 1rem;
  }

  .address-text {
    color: #6b6b7b;
    line-height: 1.7;
  }

  .social-links {
    display: flex;
    gap: 1rem;
    font-size: 1.1rem;

    a {
      color: #1e1e2d;
      transition: color 0.2s ease;

      &:hover {
        color: #d9506b;
      }
    }
  }

  .form-heading {
    font-size: 2.5rem;
    font-weight: 700;
    color: #1e1e2d;
    margin-bottom: 1rem;
  }

  .contact-title {
    font-weight: 600;
    font-size: 1.4rem;
    margin-bottom: 2rem;
    color: #1e1e2d;
  }

  .form-label {
    font-weight: 700;
    color: #1e1e2d;
    margin-bottom: 0.5rem;
  }

  .form-control {
    background: #f7f8fc;
    border: 1px solid #eceef5;
    border-radius: 12px;
    padding: 0.85rem 1rem;

    &:focus {
      box-shadow: none;
      border-color: #d9506b;
    }
  }

  textarea.form-control {
    resize: none;
  }

  .btn-dark {
    border-radius: 12px;
    padding: 0.85rem 2rem;
    font-weight: 700;
  }
}
</style>
